module.exports = Jsw.skinUrl + "/images/AI.svg?280dd77aa78a4c96365093a2f232dd9d";